import { request, ORGANISATION_BASE } from "@/api/client";
import { authHeaders } from "@/api/config";
import type { BusinessUnit } from "@/types";

export interface BusinessUnitOption extends BusinessUnit {
  code?: string;
}

interface BusinessUnitsEnvelope {
  data?: { businessUnits?: BusinessUnitOption[] };
  businessUnits?: BusinessUnitOption[];
  total_count?: number;
}

/**
 * Single source of truth for the `/organisation/v1/businessunits` query.
 * Normalizes the wrapped ({ businessUnits }) / raw-array / { data } response
 * shapes that older callers handled inconsistently.
 */
export async function fetchBusinessUnits(
  params?: { page?: number; limit?: number; emissionTarget?: true },
  token?: string,
): Promise<{ businessUnits: BusinessUnitOption[]; totalCount: number }> {
  const headers = token ? authHeaders(token).headers : undefined;
  const body = await request<BusinessUnitsEnvelope | BusinessUnitOption[]>(
    "get",
    `${ORGANISATION_BASE}/businessunits`,
    { params, headers, unwrap: false },
  );
  if (Array.isArray(body)) {
    return { businessUnits: body, totalCount: body.length };
  }
  const businessUnits = body?.data?.businessUnits ?? body?.businessUnits ?? [];
  return {
    businessUnits,
    totalCount: body?.total_count ?? businessUnits.length,
  };
}
